<div class="flex flex-row flex-nowrap md:gap-3 items-center justify-between">
  <div class="flex flex-wrap w-1/4 justify-start">
    <img
      [routerLink]="['/packs']"
      alt="img"
      class="left-arrow clickable"
      src="../../../../assets/icons/left-arrow.svg"
    />
    <h1 class="headeradminui-text pl-2">Chat with prompt</h1>
  </div>
</div>
<div class="flex flex-col gap-4 pt-4 w-full">
  <nz-select
    [(ngModel)]="selectedTemplate"
    nzPlaceHolder="Select Template"
    (ngModelChange)="getTemplate($event)"
    class="w-[50%]"
  >
    <nz-option
      *ngFor="let option of templateOptions"
      [nzValue]="option.value"
      [nzLabel]="option.label"
    ></nz-option>
  </nz-select>
  <nz-divider
    nzText="Prompt & Placeholders(it will added on typing)"
  ></nz-divider>
  <nz-list nzItemLayout="horizontal" [nzLoading]="loading">
    @for (item of placeholders; track item) {
      <nz-list-item>
        <!-- <nz-list-item-meta
          nzAvatar="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
          nzDescription="Prompt Response"
        >
          <nz-list-item-meta-title>
              <a href="https://ng.ant.design">{{ item.message }}</a>
            </nz-list-item-meta-title>
        </nz-list-item-meta> -->
        <div class="flex gap-4">
          <input
            [(ngModel)]="item.key"
            placeholder="key"
            nz-input
            [disabled]="true"
          />
          <input [(ngModel)]="item.value" placeholder="enter value" nz-input />
        </div>
      </nz-list-item>
    }
    @if (placeholders.length === 0) {
      <nz-list-empty />
    }
  </nz-list>
  <textarea
    rows="16"
    nz-input
    [(ngModel)]="promptText"
    (ngModelChange)="onTextareaChange($event)"
  ></textarea>
  <nz-divider
    nzText="Chat Messages(To start hit send message as empty)"
  ></nz-divider>
  <div class="bg-white w-full">
    <nz-list
      nzItemLayout="horizontal"
      [nzLoading]="promptLoading"
      class="demo-infinite-container"
    >
      @for (item of messages; track item) {
        <nz-list-item [attr.id]="item.id">
          <nz-list-item-meta
            nzAvatar="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
            nzDescription="Prompt Response"
          >
            <nz-list-item-meta-title>
              <a href="https://ng.ant.design">{{ item.text }}</a>
            </nz-list-item-meta-title>
            <nz-list-item-meta-title *ngIf="item.question">
              <a href="https://ng.ant.design">{{ item.question }}</a>
            </nz-list-item-meta-title>
            <nz-list-item-meta-title
              *ngIf="item.options && item.options.length"
            >
              <div
                *ngFor="let data of item.options"
                class="flex flex-wrap gap-2 mt-2"
              >
                <button nz-button (click)="sendMessage(data)">
                  {{ data }}
                </button>
              </div>
              <!-- <a href="https://ng.ant.design">{{ item.options.join(",") }}</a> -->
            </nz-list-item-meta-title>
            <nz-list-item-meta-title *ngIf="item.end_message">
              <a href="https://ng.ant.design">{{ item.end_message }}</a>
            </nz-list-item-meta-title>
            <nz-list-item-meta-title *ngIf="item.aux && item.aux.data">
              <a href="https://ng.ant.design">{{ "aux :" + item.aux.data }}</a>
            </nz-list-item-meta-title>
            <nz-list-item-meta-title *ngIf="item.not_applicable">
              <a href="https://ng.ant.design">{{ "not applicable" }}</a>
            </nz-list-item-meta-title>
            <nz-list-item-meta-title *ngIf="item.secondary_expert">
              <a href="https://ng.ant.design">{{ "secondary expert" }}</a>
            </nz-list-item-meta-title>
            <nz-list-item-meta-title *ngIf="item.slides && item.slides.length">
              <div *ngFor="let data of item.slides" class="flex flex-col gap-2">
                <a href="https://ng.ant.design">{{ "title :" + data.title }}</a>
                <a href="https://ng.ant.design">{{
                  "description :" + data.description
                }}</a>
              </div>
            </nz-list-item-meta-title>
          </nz-list-item-meta>
        </nz-list-item>
      }
      <nz-list-item #lastMessage></nz-list-item>
      @if (messages.length === 0) {
        <nz-list-empty />
      }
    </nz-list>
  </div>
  <div class="flex gap-2">
    <textarea
      rows="4"
      [(ngModel)]="messageText"
      placeholder="Enter your message"
      nz-input
    ></textarea>
    <button nz-button nzType="primary" (click)="testPrompt()">
      Send Message
    </button>
    <button nz-button (click)="clearChat()">Clear Chat</button>
  </div>
</div>
